import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntidadeRoutingModule } from './entidade-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { EntidadeSharedDataService } from './entidade-shared-data.service';
import { VinculoSharedDataService } from '@modules/vinculo/vinculo-shared-data.service';
import { PessoaSharedDataService } from '@modules/pessoa/pessoa-shared-data.service';
import { JustificativaModalComponent } from './pages/justificativa-modal/justificativa-modal.component';
import { EntidadeListComponent } from './pages/entidade-list/entidade-list.component';
import { EntidadeFormComponent } from './pages/entidade-form/entidade-form.component';
import { DadosBasicosFormComponent } from './components/dados-basicos-form/dados-basicos-form.component';
import { ObservacoesModule } from '@modules/observacoes/observacoes.module';
import { GruposComponent } from './components/grupos/grupos.component';
import { ContatoModule } from '@modules/contato/contato.module';
import { CargoFormComponent } from './components/cargo/cargo-form/cargo-form.component';
import { CargoListComponent } from './components/cargo/cargo-list/cargo-list.component';
import { EntidadeSuperiorListComponent } from './components/entidade-superior-list/entidade-superior-list.component';
import { DocumentoModule } from '@modules/documento/documento.module';
import { VinculoModule } from '@modules/vinculo/vinculo.module';
import { HistoricoListComponent } from './components/historico/historico-list/historico-list.component';
import { ArvoreListComponent } from './components/arvore/arvore-list/arvore-list.component';
import { ArvoreHierarquicaComponent } from './components/arvore-hierarquica/arvore-hierarquica.component';
import { EntidadeMovimentacaoListComponent } from './components/entidade-movimentacao-list/entidade-movimentacao-list.component';
import { AddCargoComponent } from './components/cargo/add-cargo/add-cargo.component';
import { MandatoListComponent } from './components/mandato-list/mandato-list.component';
import { AtualizacaoContatoPessoaModalComponent } from './components/atualizacao-contato-pessoa-modal/atualizacao-contato-pessoa-modal.component';
import { MovimentacaoSocietariaModule } from '@modules/movimentacao-societaria/movimentacao-societaria.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ListaNiveisDragAndDropComponent } from '@modules/dominios/components/lista-niveis-drag-and-drop/lista-niveis-drag-and-drop.component';
import { DominiosModule } from '@modules/dominios/dominios.module';

@NgModule({
  declarations: [
    EntidadeListComponent,
    EntidadeFormComponent,
    DadosBasicosFormComponent,
    GruposComponent,
    CargoFormComponent,
    CargoListComponent,
    AddCargoComponent,
    JustificativaModalComponent,
    EntidadeSuperiorListComponent,
    HistoricoListComponent,
    ArvoreListComponent,
    ArvoreHierarquicaComponent,
    EntidadeMovimentacaoListComponent,
    MandatoListComponent,

    AtualizacaoContatoPessoaModalComponent
  ],
  exports:[
    GruposComponent,
    JustificativaModalComponent
  ],
  imports: [
    CommonModule,
    EntidadeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgxPermissionsModule.forChild(),
    ObservacoesModule,
    ContatoModule,
    DocumentoModule,
    VinculoModule,
    MovimentacaoSocietariaModule,
    DominiosModule
  ],
  providers: [
    EntidadeSharedDataService,
    PessoaSharedDataService,
    VinculoSharedDataService,
    provideNgxMask()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EntidadeModule { }
